import { render } from "./EventDetailView.vue?vue&type=template&id=642bdff1"
import script from "./EventDetailView.vue?vue&type=script&lang=js"
export * from "./EventDetailView.vue?vue&type=script&lang=js"

import "./EventDetailView.vue?vue&type=style&index=0&id=642bdff1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__